<div class="advisory__content-description">
  <app-rich-content [content]="text"> </app-rich-content>
</div>
